<template>
    <div class="product-detail">
        <loader />
        <transition name="fade-up">
            <div class="rotate" v-show="loadFinished">Swipe to Rotate</div>
        </transition>
        <scene :model="currentModel"></scene>
        <div class="main-icon"></div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import collect from 'collect.js';
import Scene from '../components/spinner/scene';
import Loader from '../components/spinner/loader';
export default {
    components: { Scene, Loader },
    mounted() {
        this.setCurrentHotspot('');
    },
    computed: {
        ...mapState('products', ['products']),
        ...mapState('spinner', ['loadFinished']),
        currentModel() {
            return collect(this.products)
                .where('id', this.$route.params.id)
                .first();
        }
    },
    methods: {
        ...mapActions(['setCurrentHotspot'])
    }
};
</script>

<style lang="scss">
@import '../assets/sass/_globals/mixins';

.product-detail {
    height: 100vh;
    width: 100vw;
    margin: 0;
    top: 0;
    overflow: hidden;
    position: absolute;

    .rotate {
        padding: 0.2em 3em;
        position: absolute;
        bottom: 3em;
        left: 50%;
        transform: translateX(-50%);
        color: #004b8d;
        font-size: 0.875em;
        font-weight: 600;
        text-transform: uppercase;
        white-space: nowrap;
        z-index: 998;

        @include until($tlp) {
            bottom: 8rem;
        }

        &:before {
            content: '';
            background-image: url(../assets/imgs/icons/arrow-blue.svg);
            background-repeat: no-repeat;
            background-size: contain;
            width: 0.75em;
            height: 1em;
            position: absolute;
            top: 50%;
            left: 1.25em;
            transform: translateY(-50%) rotate(180deg);
            z-index: 1000;
        }

        &:after {
            content: '';
            background-image: url(../assets/imgs/icons/arrow-blue.svg);
            background-repeat: no-repeat;
            background-size: contain;
            width: 0.75em;
            height: 1em;
            position: absolute;
            top: 50%;
            right: 1.25em;
            transform: translateY(-50%);
            z-index: 1000;
        }
    }
}
</style>
